var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"footer",attrs:{"fluid":""}},[_c('p',{staticStyle:{"font-weight":"400"}},[_vm._v("Email: contato@universidadeparavida.com.br"),_c('br'),_vm._v("\nTelefone: (21) 98192-1700"),_c('br'),_vm._v("\nCopyright © "+_vm._s(_vm.data)+" Portal UneVida Inc. Todos os direitos reservados.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-759ff231","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 